// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D3rYR","container":"styles_container__S9GWa","bottomRow":"styles_bottomRow__tjbF9","languageSelector":"styles_languageSelector__h_fS0"};